import { ChainId } from "./index"

export const NETWORK_LABEL: Partial<Record<ChainId, string>> = {
  [ChainId.MAINNET]: "Cronos",
  [ChainId.TESTNET]: "Cronos Testnet",
}

export const NETWORK_CONFIG: {
  [chainId in ChainId]: {
    chainId: string
    chainName: string
    nativeCurrency: {
      name: string
      symbol: string
      decimals: number
    }
    rpcUrls: string[]
    blockExplorerUrls: string[]
  }
} = {
  [ChainId.MAINNET]: {
    chainId: "0x19",
    chainName: "Cronos",
    nativeCurrency: {
      name: "Cronos",
      symbol: "cro",
      decimals: 18,
    },
    rpcUrls: ["https://rpc.ferroprotocol.com"],
    blockExplorerUrls: ["https://cronos.crypto.org/explorer/"],
  },
  [ChainId.TESTNET]: {
    chainId: "0x152",
    chainName: "Cronos Testnet",
    nativeCurrency: {
      name: "Cronos",
      symbol: "cro",
      decimals: 18,
    },
    rpcUrls: ["https://cronos-testnet-3.crypto.org:8545"],
    blockExplorerUrls: ["https://cronos.crypto.org/explorer/testnet3/"],
  },
}
